<script>
import ReportResults from '@/components/ReportResults'
import Container from '@/components/Container'

export default {
  name: 'Public',
  props: {
    saveId: { type: Number, required: true }
  },
  components: {
    ReportResults,
    Container
  },
  data() {
    return {
      reportLoading: true,
      savedReport: null
    }
  },
  computed: {
    inDashboard() {
      return this.$route.query.inDash
    },
    hideDash() {
      return this.$route.query.hideDash
    }
  },
  methods: {
    loadReport() {
      this.graphql(
        /* GraphQL */ `
          query PublicReportSavedLookup($saveId: Int!) {
            allMetricsDashSaves(condition: { saveId: $saveId }) {
              nodes {
                reportName
                saveData
                metricsDashReportByReportName {
                  reportDescription
                  reportDetails
                }
              }
            }
          }
        `,
        {
          saveId: this.saveId
        }
      ).then(data => {
        this.reportLoading = false
        if (data.allMetricsDashSaves.nodes.length) {
          this.savedReport = {
            reportName: data.allMetricsDashSaves.nodes[0].reportName,
            reportRecords:
              data.allMetricsDashSaves.nodes[0].saveData.reportRecords,
            reportFields:
              data.allMetricsDashSaves.nodes[0].saveData.reportFields,
            chartType: data.allMetricsDashSaves.nodes[0].saveData.chartType,
            reportParameters:
              data.allMetricsDashSaves.nodes[0].saveData.reportParameters,
            reportDescription:
              data.allMetricsDashSaves.nodes[0].metricsDashReportByReportName
                .reportDescription,
            reportDetails:
              data.allMetricsDashSaves.nodes[0].metricsDashReportByReportName
                .reportDetails
          }
        }
      })
    },
    viewInDash() {
      this.$router.push({
        ...this.$route,
        query: {
          inDash: true
        }
      })
    }
  },
  mounted() {
    this.loadReport()
  }
}
</script>

<template>
  <div>
    <h1 v-if="!reportLoading && !savedReport">Report Not Found</h1>
    <div v-else-if="!reportLoading">
      <div
        class="text-center hide-on-print my-2"
        :class="{
          hide:
            !/base_role=postgraphile_infrastructure/.test($store.state.role) ||
            inDashboard ||
            hideDash
        }"
      >
        <b-button class="button" @click="viewInDash">
          View in Dashboard
        </b-button>
      </div>
      <Container :expanded="false">
        <template v-slot:header>
          Report Details: {{ savedReport.reportName }}
        </template>
        <template v-slot:content>
          <p
            class="m-2 text-center  report-details-description"
            v-html="savedReport.reportDescription"
          ></p>
          <div v-if="savedReport.reportDetails.formSchema">
            <hr />
            <PrintForm
              :fields="savedReport.reportDetails.formSchema"
              :data="savedReport.reportParameters"
            />
          </div>
        </template>
      </Container>
      <ReportResults
        :reportName="savedReport.reportName"
        :reportRecords="savedReport.reportRecords"
        :reportFields="savedReport.reportFields"
        :chartType="
          savedReport.chartType || savedReport.reportDetails.defaultChartType
        "
        :reportDetails="savedReport.reportDetails"
        :class="{ standalone: !inDashboard }"
        :allowFavorite="false"
        :allowSave="false"
      />
    </div>
  </div>
</template>

<style>
.standalone .options-container,
.standalone .report-container.detailsContainer > .containerHeader {
  display: none !important;
}
.standalone .report-container {
  border: unset;
  border-radius: unset;
  width: 100%;
  padding: unset;
  margin: unset;
}
.report-details-description .report-details-only {
  display: inline-block;
}
</style>
